<template>

    <SubHeader title="Liste des Motif" :breads="[{ name: 'Motif' }]" />
    <div class="row">
        <div class="col-md-12">
            <div class="card">
                <div class="card-header">
                    <div class="row justify-content-between align-items-center flex-grow-1">
                        <div class="col-12 col-md">
                            <div class="d-flex justify-content-between align-items-center"
                                v-if="checkGuard('create_no_follow_up_reason')">
                                <router-link :to="{ name: 'AdminConfigCreateMotif' }"
                                    class="btn btn-outline-primary btn-xs">
                                    <i class="bi bi-plus me-1"></i> Ajouter
                                </router-link>
                            </div>
                        </div>

                        <div class="col-auto">
                            <!-- Filter -->
                            <form>
                                <!-- Search -->
                                <div class="input-group input-group-merge input-group-flush">
                                    <div class="input-group-prepend input-group-text">
                                        <i class="bi-search"></i>
                                    </div>
                                    <input id="datatableWithSearchInput" type="search" class="form-control"
                                        placeholder="Search motif" v-model="searchWord" aria-label="Search motif">
                                </div>
                                <!-- End Search -->
                            </form>
                            <!-- End Filter -->
                        </div>
                    </div>
                </div>
                <div class="card-body datatable-custom position-relative">
                    <data-table :rows="items" :columns="cols" :loading="isLoading" :sortable="true" sortColumn="label"
                        sortDirection="asc" paginationInfo="De {0} à {1} sur un total de {2}" :search="searchWord"
                        noDataContent="Pas de resultat"
                        class="advanced-table whitespace-nowrap table table-borderless table-thead-bordered ">
                        <template #action="{ value }">
                            <div class="btn-group" role="group" aria-label="Button group with nested dropdown">

                                <!-- a href="" class="btn btn-outline-dark btn-xs" title="Voir le résumé"><i class="bi bi-eye"></i></a -->
                                <router-link :to="{ name: 'AdminConfigShowMotif', params: { id: value.id } }"
                                    class="btn btn-outline-dark btn-xs" title="Voir la fiche">
                                    <i class="bi bi-eye"></i>
                                </router-link>
                            </div>
                        </template>
                    </data-table>
                </div>

            </div>
        </div>
    </div>
</template>
<script>

import SubHeader from "@/layouts/admin/SubHeader.vue"
import { mapActions } from "vuex";
import { mapFields } from "vuex-map-fields";
import { checkGuard } from "@/utils/guards.js"


export default {
    name: "AdminConfigMotif",
    components: {
        SubHeader
    },
    data() {
        return {
            cols: [
                { field: 'label', title: 'Motif' },
                {
                    field: 'action', title: 'Actions', sort: false, width: '10px', headerClass: 'justify-center', cellClass: 'justify-center', hide: !this.checkGuard('view_any_no_follow_up_reason')
                },

            ],
            searchWord: null
        }
    },

    computed: {
        ...mapFields("motif/list", {
            isLoading: "isLoading",
            isSuccess: "isSuccess",
            showMessage: "showMessage",
            message: "message",
            items: "items"

        })
    },

    methods: {
        ...mapActions({
            getMotifs: "motif/list/getAll",
            reset: "motif/list/resetData",
        }), checkGuard,

    },
    mounted() {
        this.getMotifs()
    },
    unmounted() {
        this.reset()
    }
}
</script>
